export default {
  vehicleHeaders: [
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.drivers', 'driver'],
    ['satellite-tracking/history.crew', 'crew'],
    ['satellite-tracking/report.parking_time_machine', 'parkingTime'],
    ['satellite-tracking/report.start_time', 'startTime'],
    ['satellite-tracking/report.start_distance', 'startOdo'],
    ['satellite-tracking/report.start_address', 'startAddress'],
    ['satellite-tracking/report.end_time', 'endTime'],
    ['satellite-tracking/report.end_distance', 'endOdo'],
    ['satellite-tracking/report.end_address', 'endAddress'],
    ['satellite-tracking/report.distance', 'distance'],
    ['satellite-tracking/report.duration', 'duration'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel', 'averageFuelSpent']
  ],

  machineHeaders: [
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.drivers', 'driver'],
    ['satellite-tracking/history.crew', 'crew'],
    ['satellite-tracking/report.parking_time_machine', 'parkingTime'],
    ['satellite-tracking/report.start_time', 'startTime'],
    ['satellite-tracking/report.machine_hours_start', 'machineHoursStart'],
    ['satellite-tracking/report.start_address', 'startAddress'],
    ['satellite-tracking/report.end_time', 'endTime'],
    ['satellite-tracking/report.machine_hours_end', 'machineHoursEnd'],
    ['satellite-tracking/report.end_address', 'endAddress'],
    ['satellite-tracking/report.machine_hours', 'machineHoursTotal'],
    ['satellite-tracking/report.duration', 'duration'],
    ['satellite-tracking/report.spent_fuel', 'spentFuel'],
    ['satellite-tracking/report.average_spent_fuel_machine', 'averageFuelSpentMachine']
  ]
}
